import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const formatDate = (date: Date | string): string => {
  const d = typeof date === "string" ? new Date(date) : date;
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(d);
};

export const formatDateTime = (date: Date | string): string => {
  const d = typeof date === "string" ? new Date(date) : date;
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  }).format(d);
};

export const formatRelativeDate = (date: Date | string): string => {
  const d = typeof date === "string" ? new Date(date) : date;
  const now = dayjs();
  const target = dayjs(d);
  const hoursDiff = now.diff(target, "hour");

  if (hoursDiff < 24) {
    return target.fromNow(); // "5 minutes ago", "2 hours ago"
  }

  if (hoursDiff < 48) {
    return "Yesterday";
  }

  if (hoursDiff < 72) {
    return "2 days ago";
  }

  if (hoursDiff < 168) {
    // 7 days
    return `${Math.floor(hoursDiff / 24)} days ago`;
  }

  return formatDate(d);
};

export const formatLastModified = (date: Date | string): string => {
  const d = typeof date === "string" ? new Date(date) : date;
  const now = dayjs();
  const target = dayjs(d);
  const hoursDiff = now.diff(target, "hour");

  if (hoursDiff < 24) {
    return target.fromNow(); // "5 minutes ago", "2 hours ago"
  }

  return formatDate(d);
};
